// extracted by mini-css-extract-plugin
export default {"JobDescription":"Job_JobDescription__vxFrU","JobPageWrapper":"Job_JobPageWrapper__+jfdI"};